import { Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { getMainLocation, getSubLocations } from '../modules/location/selector';
import { BlackListRequest } from '../modules/black-list/models';
import { fetchBlackListRows } from '../modules/black-list/operations';
import { getFilters, getOpenDialog } from '../modules/black-list/selectors';
import { closeDialog, setFilters, setMainLocation } from '../modules/black-list/slice';
import { useAppDispatch, useAppSelector } from '../utils/hooks';
import DataGrid from './blackList/DataGrid';
import Filters from './blackList/Filters';
import BlackListDialog from './blackList/BlackListDialog';

const BlackList = () => {
  const dispatch = useAppDispatch();
  const mainLocation = useAppSelector((state) => getMainLocation(state.location));
  const allSubLocations = useAppSelector((state) => getSubLocations(state.location, mainLocation?.uuid));
  const filters = useAppSelector((state) => getFilters(state.blackList));
  const openDialog = useAppSelector((s) => getOpenDialog(s.blackList));

  useEffect(() => {
    const initState = async () => {
      dispatch(setMainLocation(mainLocation.uuid));
      const newFilters = {
        ...filters,
        mainLocationId: mainLocation.uuid,
        locationUuidFilter: allSubLocations && allSubLocations.length > 0 ? allSubLocations[0].uuid : '',
      } as BlackListRequest;
      await refreshGrid(newFilters);
    };
    initState();
  }, []);

  const handleOnDialogClose = async (saved: boolean) => {
    if (saved) {
      await refreshGrid(filters);
    }

    dispatch(closeDialog());
  };

  const refreshGrid = async (newFilters: BlackListRequest) => {
    dispatch(setFilters(newFilters));
    await dispatch(fetchBlackListRows(newFilters));
  };

  return (
    <>
      <Stack direction={'column'} spacing={2}>
        <Typography variant="h2" component="h2">
          Czarne listy
        </Typography>
        <Filters></Filters>
        <DataGrid />
      </Stack>
      <BlackListDialog open={openDialog} headLocation={mainLocation.uuid} onClose={handleOnDialogClose} />
    </>
  );
};

export default BlackList;
